<template lang="pug">
  .pomodoro-contain(:class="{'break-time': Isbreak}")
    .pomodoro-contain-left
      .pomodoro-admision
        input(placeholder="ADD A NEW MISSION..." @keyup.enter="addTodo")
        .material-icons add
      .now-block(v-if="Todo")
        .now-todo
          .now-todo-check.material-icons(@click="done(Todo)") radio_button_unchecked
          .now-todo-title
            div {{ Todo.title }}
            .now-todo-break-icon(v-for="pomodoro in Todo.pomodoro" :key="pomodoro" style="background: #003164; border: none")
            .now-todo-break-icon(:style="{background: bgProgress}" v-if="!Isbreak")
        .time(v-if="!Isbreak") {{ Math.floor(Todo.work_time / 60) < 10 ? '0' : '' }}{{ Math.floor(Todo.work_time / 60) }}:{{ Math.floor(Todo.work_time % 60) < 10 ? '0' : '' }}{{ Math.floor(Todo.work_time % 60) }}
        .time(v-else) {{ Math.floor(Todo.break_time / 60) < 10 ? '0' : '' }}{{ Math.floor(Todo.break_time / 60) }}:{{ Math.floor(Todo.break_time % 60) < 10 ? '0' : '' }}{{ Math.floor(Todo.break_time % 60) }}
      .now-list
        .now-todo.now-todo-ready(v-for="todo in TodoList" :key="todo.id")
          .now-todo-check.material-icons(v-if="!todo.completed" @click="done(todo)") radio_button_unchecked
          .now-todo-check.material-icons(v-else) check_circle_outline
          .now-todo-title {{ todo.title }}
          .now-todo-play.material-icons(@click="SIWTCHTODO(todo)") play_circle_outline
        .now-list-more(@click="path('list')") MORE
    .pomodoro-contain-middle(v-if="Todo")
      .pomodoro-clock(:class="{'active': Todo.play}" :style="{background: bgProgress}")
        .pomodoro-clock-button(@click="playTodo(Todo)" :class="{'active': Todo.play}")
          .material-icons(v-if="!Todo.play") play_circle_filled
          .material-icons(v-else) pause_circle_filled
    .pomodoro-contain-middle(v-else)
      .pomodoro-clock
        .pomodoro-clock-button
          .material-icons play_circle_filled
    .pomodoro-contain-right
      .pomodoro-contain-nav
        .material-icons(@click="path('list')") list
        .material-icons(@click="path('analytics')") insert_chart
        .material-icons(@click="path('ringtones')") library_music
      span.pomodoro-contain-title POMODORO
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
export default {
  methods: {
    ...mapMutations(['UPDATETODOLIST', 'SIWTCHTODO', 'SETBOARD']),
    ...mapActions(['addTodo', 'playTodo']),
    percentToDeg (percent) {
      percent = percent >= 100 ? 100 : percent
      const deg = 3.6 * percent
      return deg
    },
    done (todo) {
      todo.completed = !todo.completed
      this.UPDATETODOLIST(todo)
    },
    path (now) {
      this.SETBOARD(now)
      this.$router.push('dashboard')
    }
  },
  computed: {
    ...mapGetters(['TodoList', 'Todo', 'Isbreak']),
    bgProgress () {
      const percnet = this.Isbreak ? 100 - (this.Todo.break_time / 300) * 100 : 100 - (this.Todo.work_time / 1500) * 100
      let deg = this.percentToDeg(percnet)
      let gressMain, gressBack
      if (this.Isbreak) {
        gressMain = '#00A7FF'
        gressBack = '#E5F3FF'
      } else {
        gressMain = '#FF4384'
        gressBack = '#FFEDF7'
      }
      if (deg <= 180) {
        deg = deg + 90
        return `linear-gradient(90deg, ${gressBack} 50%, transparent 50%), linear-gradient(${deg}deg, ${gressMain} 50%, transparent 50%)`
      } else {
        deg = deg - 90
        return `linear-gradient(-90deg, ${gressMain} 50%, transparent 50%), linear-gradient(${deg}deg, ${gressBack} 50%, ${gressMain} 50%)`
      }
    }
  }
}
</script>
